import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';



import { FormInputParagraph } from '@components/form-input-paragraph/form-input-paragraph';
import { FormInput } from '@components/form-input/form-input';
import { FormTextarea } from '@components/form-textarea/form-texarea';
import { Field } from 'formik';
import { getStandardService } from 'src/standard/infrastructure/getters';


export const CreateNewStandardEAFormScopeJustification = observer(() => {
	const url = window.location.href;
	const { t } = useTranslation();

	const standardService = getStandardService();

	useEffect(() => {
		const onLoadPage = async () => {
			standardService.getStandardList(20, 0, false);
		};

		onLoadPage();
	}, [standardService]);

	return (
		<>
			<Field
				component={FormTextarea}
				name="standardTitleEN"
				title={t('standard.createNWP.titles.standardTitleEN')}
				placeholder={t('standard.createNWP.titles.standardTitleENPlaceholder')}
				fullWidth
				mandatory={!standardService.singleStandard?.isMigrated}
				showError
				maxLength={1000}
				useSubmitOnBlur
				disableMaxLength={url.includes('draft')}
			/>
			<Field
				component={FormTextarea}
				name="standardTitleDE"
				title={t('standard.createNWP.titles.standardTitleDE')}
				placeholder={t('standard.createNWP.titles.standardTitleDEPlaceholder')}
				fullWidth
				maxLength={1000}
				useSubmitOnBlur
				disableMaxLength={url.includes('draft')}
			/>
			<Field
				component={FormTextarea}
				name="standardTitleFR"
				title={t('standard.createNWP.titles.standardTitleFR')}
				placeholder={t('standard.createNWP.titles.standardTitleFRPlaceholder')}
				fullWidth
				maxLength={1000}
				useSubmitOnBlur
				disableMaxLength={url.includes('draft')}
			/>
			<Field
				component={FormInputParagraph}
				name="scope"
				title={t('standard.createNWP.general.scopeTitle')}
				mandatory={!standardService.singleStandard?.isMigrated}
				fullWidth
				maxLength={5000}
				showError
				useSubmitOnBlur
				disableMaxLength={url.includes('draft')}
			/>

			<Field
				component={FormInputParagraph}
				name="purpose"
				title={t('standard.createNWP.justification.purpose')}
				fullWidth
				maxLength={5000}
				useSubmitOnBlur
				disableMaxLength={url.includes('draft')}
			/>
		</>
	);
});
